/**
 * 视频上传与预览组件
 */

import React, { useState, useRef } from 'react'

export default function VideoUploader({ onVideoSelect, videoFile, disabled }) {
  const [dragOver, setDragOver] = useState(false)
  const [previewUrl, setPreviewUrl] = useState(null)
  const inputRef = useRef(null)

  const handleFile = (file) => {
    if (!file) return
    if (!file.type.startsWith('video/')) {
      alert('请选择视频文件')
      return
    }
    if (file.size > 500 * 1024 * 1024) {
      alert('视频文件过大，请控制在 500MB 以内')
      return
    }

    const url = URL.createObjectURL(file)
    setPreviewUrl(url)
    onVideoSelect(file)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setDragOver(false)
    const file = e.dataTransfer.files[0]
    handleFile(file)
  }

  const handleChange = (e) => {
    const file = e.target.files[0]
    handleFile(file)
  }

  const clearVideo = () => {
    if (previewUrl) URL.revokeObjectURL(previewUrl)
    setPreviewUrl(null)
    onVideoSelect(null)
    if (inputRef.current) inputRef.current.value = ''
  }

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>🎬 上传短视频</h3>

      {!previewUrl ? (
        <div
          onDrop={handleDrop}
          onDragOver={(e) => { e.preventDefault(); setDragOver(true) }}
          onDragLeave={() => setDragOver(false)}
          onClick={() => inputRef.current?.click()}
          style={{
            ...styles.dropZone,
            ...(dragOver ? styles.dropZoneActive : {}),
            ...(disabled ? styles.dropZoneDisabled : {}),
          }}
        >
          <div style={styles.icon}>📁</div>
          <div style={styles.hint}>点击或拖拽上传视频</div>
          <div style={styles.subHint}>支持 MP4, MOV, WebM 等格式，最大 500MB</div>
          <input
            ref={inputRef}
            type="file"
            accept="video/*"
            onChange={handleChange}
            style={{ display: 'none' }}
            disabled={disabled}
          />
        </div>
      ) : (
        <div style={styles.previewContainer}>
          <video
            src={previewUrl}
            controls
            style={styles.video}
            preload="metadata"
          />
          <div style={styles.fileInfo}>
            <span style={styles.fileName}>{videoFile?.name}</span>
            <span style={styles.fileSize}>
              {(videoFile?.size / 1024 / 1024).toFixed(2)} MB
            </span>
          </div>
          <button onClick={clearVideo} style={styles.clearButton} disabled={disabled}>
            移除视频
          </button>
        </div>
      )}
    </div>
  )
}

const styles = {
  container: {
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    borderRadius: '16px',
    padding: '24px',
    border: '1px solid rgba(138, 43, 226, 0.3)',
    marginBottom: '20px',
  },
  title: {
    margin: '0 0 16px 0',
    color: '#e2e8f0',
    fontSize: '18px',
  },
  dropZone: {
    border: '2px dashed rgba(138, 43, 226, 0.4)',
    borderRadius: '12px',
    padding: '40px 20px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: 'rgba(15, 23, 42, 0.3)',
  },
  dropZoneActive: {
    borderColor: '#8a2be2',
    background: 'rgba(138, 43, 226, 0.1)',
  },
  dropZoneDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '12px',
  },
  hint: {
    color: '#e2e8f0',
    fontSize: '16px',
    fontWeight: 500,
    marginBottom: '8px',
  },
  subHint: {
    color: '#64748b',
    fontSize: '12px',
  },
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  video: {
    width: '100%',
    maxHeight: '360px',
    borderRadius: '12px',
    background: '#000',
  },
  fileInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 14px',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '8px',
  },
  fileName: {
    color: '#e2e8f0',
    fontSize: '13px',
    wordBreak: 'break-all',
  },
  fileSize: {
    color: '#94a3b8',
    fontSize: '12px',
    flexShrink: 0,
  },
  clearButton: {
    padding: '10px 16px',
    borderRadius: '8px',
    border: '1px solid rgba(239, 68, 68, 0.4)',
    background: 'rgba(239, 68, 68, 0.1)',
    color: '#ef4444',
    fontSize: '13px',
    cursor: 'pointer',
    alignSelf: 'flex-start',
  },
}